import Modal from "react-bootstrap/Modal";
import { THEME_COLOR } from "../../config/club";
import BulkAddSection from "../BulkAddSection";
import PlayersListSection from "../PlayersListSection";
import TeamsSection from "./TeamsSection";
import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { CLUB_ID } from "../../config/club";
export default function PlayersModal({
    show,
    onClose,
    setShowScan,

    /* players-related props */
    sessionId,
    searchTerm,
    setSearchTerm,
    players,
    filteredPlayers,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    playerLevels,
    gamesPlayed,
    playingNames,
    queuedMatchesNames,
    queue,
    playerStatusById,
    setQueue,
    setPlayers,
    matchHistory,
    getPlayerLevelMatchStats,
    updatePlayerLevel,
    levelColor,
    ToastShow,
    addPlayers2,
}) {
    const themeAlpha = (opacity) => `${THEME_COLOR}${opacity}`;


    const [teams, setTeams] = useState([]);
    const [teamPlayers, setTeamPlayers] = useState({});

   useEffect(() => {
    if (!sessionId) return;

    const teamPlayerUnsubs = [];

    const unsubTeams = onSnapshot(
        collection(
            db,
            "clubs",
            CLUB_ID,
            "sessions",
            sessionId,
            "teams"
        ),
        (snap) => {
            const teamsData = snap.docs.map((d) => ({
                id: d.id,
                ...d.data(),
            }));

            setTeams(teamsData);

            // cleanup previous player listeners
            teamPlayerUnsubs.forEach((u) => u());
            teamPlayerUnsubs.length = 0;

            const playersMap = {};

            teamsData.forEach((team) => {
                const unsubPlayers = onSnapshot(
                    collection(
                        db,
                        "clubs",
                        CLUB_ID,
                        "sessions",
                        sessionId,
                        "teams",
                        team.id,
                        "players"
                    ),
                    (playersSnap) => {
                        playersMap[team.id] = playersSnap.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));

                        setTeamPlayers((prev) => ({
                            ...prev,
                            [team.id]: playersMap[team.id],
                        }));
                    }
                );

                teamPlayerUnsubs.push(unsubPlayers);
            });
        }
    );

    return () => {
        unsubTeams();
        teamPlayerUnsubs.forEach((u) => u());
    };
}, [sessionId]);
    return (
        <Modal
            show={show}
            onHide={onClose}
            size="xl"
            fullscreen="md-down"
            centered
            scrollable
            contentClassName="border-0 shadow-lg rounded-5"
        >
            {/* HEADER */}
            <Modal.Header closeButton className="border-0 px-4 pt-4">
                <Modal.Title
                    className="fw-bold d-flex align-items-center"
                    style={{ color: THEME_COLOR }}
                >
                    <div
                        className="rounded-3 d-flex align-items-center justify-content-center me-3"
                        style={{
                            width: 40,
                            height: 40,
                            backgroundColor: themeAlpha("10"),
                        }}
                    >
                        <i className="bi bi-people-fill"></i>
                    </div>
                    Players
                </Modal.Title>
            </Modal.Header>

            {/* BODY */}
            <Modal.Body className="px-0 pb-4">
                {/* Top Accent Bar */}


                <div className="p-4">
                    {/* <div className="d-flex align-items-center justify-content-between mb-3">
            <button
              className="btn btn-primary rounded-pill"
              onClick={() => setShowScan(true)}
            >
              <i className="bi bi-qr-code-scan me-2" />
              Scan Player
            </button>
          </div> */}
                    <TeamsSection
                        sessionId={sessionId}
                        players={players}
                        teams={teams}
                        teamPlayers={teamPlayers}
                        setTeams={setTeams}
                        setTeamPlayers={setTeamPlayers}
                    />
                    <BulkAddSection
                        addPlayers={addPlayers2}
                        existingPlayers={players}
                        THEME_COLOR={THEME_COLOR}
                        levelColor={levelColor}
                    />

                    <PlayersListSection
                        {...{
                            sessionId,
                            searchTerm,
                            setSearchTerm,
                            players,
                            filteredPlayers,
                            sortBy,
                            setSortBy,
                            sortDirection,
                            setSortDirection,
                            playerLevels,
                            gamesPlayed,
                            playingNames,
                            queuedMatchesNames,
                            queue,
                            playerStatusById,
                            setQueue,
                            setPlayers,
                            matchHistory,
                            getPlayerLevelMatchStats,
                            updatePlayerLevel,
                            levelColor,
                            ToastShow,
                        }}
                        teams={teams}
                        teamPlayers={teamPlayers}
                        setTeams={setTeams}
                        setTeamPlayers={setTeamPlayers}
                    />
                </div>
            </Modal.Body>

            {/* STYLE INJECTION (matches SettingsModal vibe) */}
            <style>{`
        .modal-content {
          border-radius: 28px !important;
        }
        .btn-close:focus {
          box-shadow: none;
        }
      `}</style>
        </Modal>
    );
}
